import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_LIGHT} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    btn: {
        color: SV_LIGHT.accent,
        backgroundColor: '#fff',
        fontWeight:'400',
        fontSize:'12px',
        '.darkTheme&':{
            backgroundColor: SV_LIGHT.accentSoft,

        },
        ':hover':{
            backgroundColor: '#fff',
        }
    },

}